import React, { Component } from "react";

class EnsaCard extends Component {
    render() { 
        require("./Ensa.css");
        const { title, children } = this.props;
        return (
            <div className="cardLine">
                <div className="card-section">
                    <div className="content">
                        <div className="title">
                            <h1 >{title}</h1>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}
 
export default EnsaCard;